export default "__VITE_ASSET__Cl9ikhOf__"